var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-danger"},[_c('b',[_vm._v("Ticket Closed")]),_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.ticket.closing_note)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }